import React from 'react';
import PropTypes from 'prop-types';

import Card from 'bundles/apex/card';

export default function DetailsCard({ children, tbodyRef, ...props }) {
  return (
    <Card {...props}>
      <table className="table table-borderless">
        <tbody ref={tbodyRef}>
          {children}
        </tbody>
      </table>
    </Card>
  );
}

DetailsCard.propTypes = {
  children: PropTypes.node.isRequired,
  tbodyRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};
